import { Card, Col, Row } from "antd";
import type { Project } from "../../../types/projects";
import dayjs from "dayjs";
import spacing from "../../../components/ui/spacingConfig";

type Props = {
  projectData: Project | undefined;
  className?: string;
};

const CardDatePlaceProject: React.FC<Props> = ({ projectData, className }) => {
  return (
    <Card title="Date et lieu" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Site</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{projectData?.site?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">PrÃ©cision</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{projectData?.localisation}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de la dÃ©claration</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {projectData?.dateCreated
              ? dayjs(projectData.dateCreated).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date du projet</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {projectData?.dateEvt
              ? dayjs(projectData.dateEvt).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de modification</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {projectData?.dateLastModif
              ? dayjs(projectData.dateLastModif).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDatePlaceProject;
